var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTree = function SvgIconTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.252a7.38 7.38 0 0 0-6.764 4.435A7 7 0 0 0 11 18.444v3.306a1 1 0 1 0 2 0v-3.306a7.002 7.002 0 0 0 9.768-5.753 7 7 0 0 0-4.004-7.004A7.38 7.38 0 0 0 12 1.252m1 14.92a5 5 0 0 0 7.164-1.704 5 5 0 0 0-2.36-7.022c-.374-.187-.671-.5-.84-.882l-.008-.018a5.374 5.374 0 0 0-9.912 0l-.008.018a1.8 1.8 0 0 1-.88.902A5 5 0 1 0 11 16.17v-1.303l-3.947-1.974a1 1 0 1 1 .894-1.788L11 12.632V8.25a1 1 0 1 1 2 0v2.132l3.053-1.526a1 1 0 1 1 .894 1.788L13 12.618v3.554",
    clipRule: "evenodd"
  })));
};
export default SvgIconTree;